module.exports = __webpack_public_path__ + "static/media/icon_anxudingzhi.c25d6a98.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/icon_anxudingzhi.svg
// module id = 522
// module chunks = 0